export default __webpack_public_path__ + "static/curriculum-79ab701da29025e9b7b3babdda3b45c7.mp4";